import { gql } from '@grandvisionhq/graphql';

const regularTypeDetails = gql`
  fragment RegularTypeDetailsFragment on RegularTypeDetails {
    isSubscription
    subscriptionDetails {
      deliveryInterval
    }
    __typename
  }
`;

export { regularTypeDetails };
//# sourceMappingURL=regular.js.map
